<template>
  <div v-show="modal" id="modal">
    <div @click="$emit('close')" class="modal__overlay"></div>

    <keep-alive>
      <component :is="modalName" :meditation="meditation" :recipe="recipe" @action="handleAction" @close="$emit('close')" @changeModal="$emit('changeModal', $event)" />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "ModalComponent",

  props: ["modal", "meditation", "recipe"],

  data() {
    return {
    }
  },

  computed: {
    modalName() {
      return `${this.modal}-modal`;
    },
  },

  methods: {
    handleAction(event) {
      this.$emit('action', event);
      this.$emit('close');
    }
  },
}
</script>

<style lang="sass">
#modal
  display: flex
  justify-content: center
  align-items: center
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  z-index: 102
  width: 100%
  height: 100%

.modal__overlay
  position: absolute
  top: 0
  left: 0
  right: 0
  bottom: 0
  background: rgba(0, 34, 43, 0.6)

.modal__form
  display: flex
  flex-direction: column
  background: rgba(30, 30, 30, 1)
  border-radius: 24px
  padding: 32px 20px
  max-width: 410px
  width: 100%
  z-index: 1

  .modal__header
    display: flex
    align-items: center
    justify-content: center
    margin-bottom: 26px

    h2
      font-size: 1.5rem
      line-height: 2rem
      font-weight: 700
      text-align: center
      color: #ffffff
      margin: 0

  .fields
    display: flex
    flex-direction: column
    gap: 16px
    margin-bottom: 32px

    label
      display: flex
      flex-direction: column
      position: relative
      gap: 4px
      color: #ffffff

      &.field_error
        input
          border: 1px solid rgba(249, 0, 0, 1)

      .error
        padding: 0
        font-size: 0.875rem
        line-height: 1.3rem
        color: rgba(249, 0, 0, 1)

      .show-password
        //display: flex
        display: none
        justify-content: center
        align-items: center
        width: 48px
        height: 48px
        position: absolute
        right: 0
        top: 28px
        cursor: pointer

      input
        outline: none
        border: none
        background: rgba(48, 48, 48, 1)
        padding: 12px 48px 12px 16px
        color: #ffffff
        font-size: 1rem
        line-height: 1.5rem
        font-weight: 400
        border-radius: 4px

        &:focus
          border: 1px solid rgba(48, 48, 48, .2)

      span
        text-align: left
        font-size: 1rem
        line-height: 1.5rem
        font-weight: 400
        color: #ffffff

  .modal__footer
    display: flex
    flex-direction: column
    gap: 12px
    margin-top: 40px
    padding: 0

    &:before
      content: unset

    a
      cursor: pointer
      text-decoration: underline
      text-align: left
      color: rgba(255, 255, 255, 1)

.modal__form
  header
    position: relative

    .img
      display: flex
      justify-content: center
      align-items: center
      padding: 12px
      cursor: pointer
      position: absolute
      right: 0
      background: rgba(48, 48, 48, 1)
      width: 40px
      height: 40px
      top: 50%
      transform: translateY(-50%)
      border-radius: 50%
      transition: .3s ease

      img
        width: 24px
        height: 24px

      &:hover
        background: rgba(48, 48, 48, .6)

      &:active
        background: rgba(48, 48, 48, .8)

.terms
  display: flex
  flex-direction: column
  position: relative
  max-width: 513px
  width: 100%
  background: rgba(255, 255, 255, 1)
  border-radius: 16px
  z-index: 1

  .terms__content, header
    padding: 16px

    a
      color: rgb(0, 0, 238)

  header
    display: flex
    flex-direction: column
    align-items: center
    border-bottom: 1px solid rgba(207, 207, 207, 1)
    position: relative

    .img
      display: flex
      justify-content: center
      align-items: center
      padding: 12px
      cursor: pointer
      position: absolute
      width: 40px
      height: 40px
      right: 16px
      background: #ffffff
      top: 50%
      transform: translateY(-50%)
      border-radius: 50%
      transition: .3s ease

      img
        width: 24px
        height: 24px

      &:hover
        background: rgba(240, 240, 240, 1)

      &:active
        background: rgba(219, 219, 219, 1)

    span
      color: #000000
      font-size: 0.725rem
      line-height: 1rem
      font-weight: 400

    h2
      font-size: 1.125rem
      line-height: 1.5rem
      margin-bottom: 6px
      font-weight: 500
      color: #000000

  .terms__content
    display: flex
    flex-direction: column
    align-items: flex-start
    max-height: 80lvh
    overflow-y: auto

    p, h3, li, b, h6
      font-size: 0.875rem
      line-height: 1.125rem
      color: #000000
      margin-bottom: 8px
      text-align: left

    a
      text-decoration: underline

    li
      font-weight: 400
      margin-bottom: 2px

      &:last-child
        margin-bottom: 0

    p
      font-weight: 400

      &.no-margin
        &:not(&:last-child)
          margin: 0

      &:last-child
        margin-bottom: 0

    h3
      font-weight: 700
</style>
